import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

interface VariableFieldProps {
    label: string;
    labelWidth?: number;
    children: string;
}

/**
 * One label/value row, shared by the picker's info card and the detail panel so the two read alike.
 *
 * `pre-line` because a resolved value may carry line breaks (an address, a list written one per
 * line); collapsing them into one run of text shows the author something the guest never sees.
 */
export const VariableField = ({label, labelWidth = 64, children}: VariableFieldProps) => (
    <Stack direction="row" gap={1}>
        <Typography variant="body2" color="text.disabled" sx={{minWidth: labelWidth}}>{label}</Typography>
        <Typography variant="body2" color="text.secondary" sx={{wordBreak: "break-word", whiteSpace: "pre-line"}}>
            {children}
        </Typography>
    </Stack>
);

export default VariableField;
